import React from "react";
import banner1 from "../../../../../assets/images/hero-image.webp";
import banner2 from "../../../../../assets/images/hero-image2.webp";
import "../../../../Pages/Homepage/Sections/BannerSection/BannerSection.scss";
import Translate from "react-translate-component";
import ScrollAnimation from "react-animate-on-scroll";
import { Animated } from "react-animated-css";
import Button from "./../../../../UI/Button/Button";

const BannerSection = (props) => {
  return (
    <section className="BannerSection" id={props.scrollAnchor}>
      <div className="row no-gutters">
        <div className="col-12 title">
          <Animated animationIn="fadeIn">
            <ScrollAnimation
              animateIn="fadeInLeft"
              animateOnce={true}
              delay={props.delay}
            >
              <Translate
                content="homepage.banner.headline_first_part"
                component="h1"
                style={{ marginBottom: "0" }}
              />
            </ScrollAnimation>
            <ScrollAnimation
              animateIn="fadeInRight"
              animateOnce={true}
              delay={props.delay}
            >
              <Translate
                content="homepage.banner.headline_second_part"
                component="h1"
                style={{ paddingTop: "0" }}
              />
            </ScrollAnimation>
            <Translate
              content="homepage.banner.subtitle"
              component="p"
              unsafe
            />
          </Animated>
        </div>
        <div className="col-12 col-lg-6 banner-image">
          <img src={banner1} alt="" />
          <div className="info col-12">
            <Button
              className="orange-dark is-bigger is-wider"
              onClick={() =>
                window.open(`${process.env.REACT_APP_AUTH_HOMECARE_URI}`)
              }
            >
              <Translate
                content="homepage.banner.login-homecare"
                component="span"
                unsafe
              />
            </Button>
            <Translate content="homepage.banner.text1" component="p" unsafe />
          </div>
          <div className="gradient left"></div>
          <div className="line left"></div>
        </div>
        <div className="col-12 col-lg-6 banner-image">
          <img src={banner2} alt="" />
          <div className="info col-12">
            <Button
              className="green-dark is-bigger is-wider"
              onClick={() => window.open(`${process.env.REACT_APP_AUTH_URI}`)}
            >
              <Translate
                content="homepage.banner.login-client"
                component="span"
                unsafe
              />
            </Button>
            <Translate content="homepage.banner.text2" component="p" unsafe />
          </div>
          <div className="gradient right"></div>
          <div className="line right"></div>
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
